import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './reducer'
import * as state from './state'

export const taskAccessState = createFeatureSelector<state.State>('task-access')

export const selectAllTaskAccesses = createSelector(taskAccessState, reducer.selectAll)
export const selectUnarchivedTaskAccesses = createSelector(selectAllTaskAccesses, (items) =>
  items.filter((t) => !t.archived)
)

export const selectTaskAccessEntities = createSelector(taskAccessState, reducer.selectEntities)

export const isUpdatingTaskAccess = createSelector(taskAccessState, (state: state.State) => state.isUpdating)

export const selectTaskAccessesLoaded = createSelector(taskAccessState, (state: state.State) => state.isLoaded)

export const selectTaskAccessByTaskId = (taskId: string) =>
  createSelector(selectAllTaskAccesses, (tasks) => tasks.find((t) => t.task_id === taskId))

export const selectTaskAccessesByTaskIds = (taskIds: string[]) =>
  createSelector(selectAllTaskAccesses, (tasks) => tasks.filter((t) => taskIds.includes(t.task_id)))
